import { isNil } from 'ramda'

import type { Category } from '@twisto/api-cms'

export const getTopLevelCategoryAttributes = (
  attributes: Category | undefined
): Category | undefined => {
  if (isNil(attributes?.parent)) {
    return attributes
  }

  return getTopLevelCategoryAttributes(attributes.parent as Category)
}

/*
  Use this check to:
  1. expand the navigation only within its current tree
  2. highlight active links
*/
export const isCurrentSubtree = (
  checkedPath: string | undefined,
  urlPath: string
) => {
  if (checkedPath === undefined) {
    return false
  }

  const withoutFirstSlash = checkedPath.substring(checkedPath.indexOf('/') + 1)
  const fromSecondSlash = withoutFirstSlash.substring(
    withoutFirstSlash.indexOf('/')
  )

  return urlPath.includes(fromSecondSlash)
}
